"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectActivityType = void 0;
var ProjectActivityType;
(function (ProjectActivityType) {
    ProjectActivityType["POST"] = "POST";
    ProjectActivityType["MILESTONE"] = "MILESTONE";
    ProjectActivityType["TRACKED_DATA"] = "TRACKED_DATA";
    ProjectActivityType["FILE_UPLOAD"] = "FILE_UPLOAD";
    ProjectActivityType["TASK"] = "TASK";
})(ProjectActivityType = exports.ProjectActivityType || (exports.ProjectActivityType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvamVjdC1hY3Rpdml0eS10eXBlLWVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tbW9uL2VudW1zL3Byb2plY3QtYWN0aXZpdHktdHlwZS1lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILElBQVksbUJBTVg7QUFORCxXQUFZLG1CQUFtQjtJQUM3QixvQ0FBYSxDQUFBO0lBQ2IsOENBQXVCLENBQUE7SUFDdkIsb0RBQTZCLENBQUE7SUFDN0Isa0RBQTJCLENBQUE7SUFDM0Isb0NBQWEsQ0FBQTtBQUNmLENBQUMsRUFOVyxtQkFBbUIsR0FBbkIsMkJBQW1CLEtBQW5CLDJCQUFtQixRQU05QiJ9